import parseDomNodeContents from 'common/utils/parse-dom-node-contents';
import { readCookie } from 'common/utils/browser-cookie';

export const CONSENT_COOKIE = '__Secure-dbx_consent';
export const CONSENT_CHANGED_EVENT = 'dropbox:privacy-consent-changed';

type ConsentCategories = Record<string, boolean>;

function readConsentCategories(): ConsentCategories {
  try {
    const consentCookie = readCookie(CONSENT_COOKIE);
    if (!consentCookie) {
      return {};
    }

    const consent = JSON.parse(consentCookie) as {
      categories?: ConsentCategories;
    };
    if (
      !consent.categories ||
      typeof consent.categories !== 'object' ||
      Array.isArray(consent.categories)
    ) {
      return {};
    }

    return consent.categories;
  } catch {
    return {};
  }
}

function isGPCEnabled(): boolean {
  return Boolean(
    (navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl,
  );
}

function readAnalyticsConsentCookie(): boolean {
  const resolvedCategories = readConsentCategories();
  return (
    resolvedCategories.all === true || resolvedCategories.analytics === true
  );
}

export function isPAPAnalyticsConsentGateEnabled(): boolean {
  try {
    const runtimeEnvironment = parseDomNodeContents('hs-env') as {
      papAnalyticsConsentGateEnabled?: boolean;
    };
    return runtimeEnvironment.papAnalyticsConsentGateEnabled === true;
  } catch {
    return false;
  }
}

export function isMarketingAttributionCookieConsentGateEnabled(): boolean {
  try {
    const rawContent = document.getElementById('hs-env')?.textContent?.trim();
    if (!rawContent) {
      return false;
    }

    const runtimeEnvironment = JSON.parse(rawContent) as {
      marketingAttributionCookieConsentGateEnabled?: boolean;
    };
    return (
      runtimeEnvironment.marketingAttributionCookieConsentGateEnabled === true
    );
  } catch {
    return false;
  }
}

export function hasAnalyticsConsent(): boolean {
  return !isGPCEnabled() && readAnalyticsConsentCookie();
}
